import React, {FC, useCallback, useMemo} from 'react';

import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {RecipientGroupMatchModel, RRecipientGroupMatch} from '../../../../models/api/recipientMatchModel';
import {VisualRecipientModel} from '../../../../models/api/visualRecipientModel';
import {AsyncDropdownSource, DropdownFetcher} from '../source/asyncDropdownSource';
import {AutocompleteDropdown} from './autocompleteDropdown';
import {RecipientDropdownItem} from './recipientDropdownItem';
import {RecipientGroupDropdownItem} from './recipientGroupDropdownItem';

/*
 * Props.
 */

interface RecipientsDropdownProps extends DropdownProps {
  fetcher: DropdownFetcher<VisualRecipientModel | RecipientGroupMatchModel>;
  query: string;
  onRecipientSelect: (recipient: VisualRecipientModel, position: number) => void;
  onGroupSelect: (group: RecipientGroupMatchModel, position: number) => void;
}

/*
 * Component.
 */

export const RecipientsDropdown: FC<RecipientsDropdownProps> = (props) => {
  const {fetcher, onRecipientSelect, onGroupSelect} = props;
  const renderRow = useCallback(
    (recipientOrGroup: VisualRecipientModel | RecipientGroupMatchModel, index: number) => {
      if (RRecipientGroupMatch.is(recipientOrGroup)) {
        return (
          <RecipientGroupDropdownItem
            key={recipientOrGroup.id}
            group={recipientOrGroup}
            onSelect={() => onGroupSelect(recipientOrGroup, index + 1)}
          />
        );
      }

      return (
        <RecipientDropdownItem
          key={recipientOrGroup.contact.uid}
          recipient={recipientOrGroup}
          onSelect={() => onRecipientSelect(recipientOrGroup, index + 1)}
        />
      );
    },
    [onGroupSelect, onRecipientSelect],
  );

  const source = useMemo(
    () =>
      new AsyncDropdownSource({
        fetcher,
        renderRow,
      }),
    [fetcher, renderRow],
  );
  return <AutocompleteDropdown {...props} source={source} maxWidth={300} />;
};
